<div
     snAssistantSurface="newAgent"
     i18n-surfaceTitle="@@newAgent.surface"
     surfaceTitle="New agent" class="agent-create-container">
  <form [formGroup]="createForm" (ngSubmit)="onSubmit()">
    <!-- Header -->
    <div class="header-section">
      <h1>{{ isDuplicating() ? duplicateTitle : createTitle }}</h1>
      <p class="subtitle" i18n="@@agentCreate.subtitle">Choose a name that reflects your agent's purpose</p>
    </div>

    <!-- Agent Name Field -->
    <div class="form-field">
      <label class="field-label">
        <span i18n="@@agentCreate.name.label">Agent Name</span> <span class="required">*</span>
      </label>

      <div class="input-wrapper">
        <input
          [snAssistantId]="F.title"
          pInputText
          type="text"
          formControlName="title"
          i18n-placeholder="@@agentCreate.name.placeholder"
          placeholder="Enter agent name"
          class="name-input"
          [maxlength]="maxNameLength">

        <span class="character-count">{{ titleLength }}/{{ maxNameLength }}</span>
      </div>

      @if (titleControl?.invalid && titleControl?.touched) {
        <div class="field-error">
          @if (titleControl?.errors?.['required']) {
            <span i18n="@@agentCreate.name.required">Agent name is required</span>
          }
          @if (titleControl?.errors?.['maxlength']) {
            <span>{{ maxLengthError }}</span>
          }
        </div>
      }
    </div>

    <!-- Action Buttons -->
    <div class="actions-section">
      <p-button
        type="button"
        i18n-label="@@common.back"
        label="Back"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-arrow-left"
        (click)="goBack()">
      </p-button>

      <p-button
        type="submit"
        [label]="isDuplicating() ? duplicateSubmitLabel : createSubmitLabel"
        [loading]="loading()"
        [disabled]="createForm.invalid"
        snAssistantAction="create"
        actionHint="Creates the agent under this name and opens its editor. When the page was opened from Duplicate, it copies the source agent instead — prompt, models and tools included.">
      </p-button>
    </div>
  </form>
</div>